<ng-container *ngIf="!retoma">
    <div class="carro-compra">
        <div class="overlay"></div>
        <div class="card-principal mt-10">
            <div *ngIf="screenSize <= 1199" class="row">
                <div class="col-12">
                    <i class="icon-circle-close-big" (click)="carroComprasService.hide()"></i>
                    <!-- <img class="icon-close pr-10" src="assets/icons/ico-close.png" alt="cerrar" (click)="firstAction()"> -->
                </div>
            </div>
            <app-codigo-descuento *ngIf="discountBox && !isWix"></app-codigo-descuento>
            <div class="carro__grilla-noproductos" *ngIf="!carroCompraVacio">
                <p class="noproductos__titulo">Aún no seleccionas ningún producto</p>
                <p>Para completar tu contrato debes tener un producto agregado.</p>
                <button class="btn-secondary-tbk-L" (click)="agregarProductos()">Agregar
                    productos</button>
            </div>
            <div *ngIf="carroCompraVacio">
                <ng-container *ngIf="!modificarTitulo; else cambioTitulo">
                    <div class="row">
                        <div class="col-12 p-0">
                            <div class="c-titulo-producto">
                                Estás solicitando {{ products.length }}
                                <ng-container *ngIf="products.length > 1; else onlyOne">productos</ng-container>
                                <ng-template #onlyOne>producto</ng-template>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #cambioTitulo>
                    <div class="row">
                        <div class="col-12 p-0">
                            <div class="c-titulo-producto">
                                Tus productos
                            </div>
                        </div>
                    </div>

                </ng-template>

                <!-- Seccion asociada a Disclaimer de Rubro Riesgoso-->
                <div *ngIf="rubroSeleccionado && rubroSeleccionado.mcc && rubroSeleccionado.mcc.includes('MCC')">
                    <hr>
                    <div class="row">
                        <div class="col-12 p-0">
                            <div class="c-rubro-riesgoso-disclaimer mx-14">
                                Según el rubro de tu comercio podría haber un
                                <a href="#" class="alert-link"
                                    (click)="abrirCobroAdicionalmodal(); $event.preventDefault()">
                                    cobro adicional relacionado
                                </a>.
                            </div>
                        </div>
                    </div>
                    <hr>
                </div>
                <!-- END - Seccion asociada a Disclaimer de Rubro Riesgoso-->

                <app-products-wrapper [products]="products"></app-products-wrapper>
                <div *ngIf="!esPaso3" class="row align-items-center">
                    <div class="btn-center ">
                        <button (click)="modificarProductos()" *ngIf="!carroCompraSeleccionBtn"
                            class="btn-secondary-tbk-L c-custom-btn">{{textoBoton}}</button>
                        <button (click)="modificarProductos()" *ngIf="carroCompraSeleccionBtn"
                            class=" btn-primary-tbk c-custom-btn">{{textoBoton}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>